import { request } from '@/api/apiUtils';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { IFountainScene, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const FOUNTAIN_SCENES_ROOT = ['fountain', 'scenes'] as const;

interface FountainScenesListParams {
    projectId: number;
    version?: string;
}

const fetchers = {
    list: {
        key: ({ projectId, version }: FountainScenesListParams) =>
            [...FOUNTAIN_SCENES_ROOT, version !== undefined ? { projectId, version } : { projectId }] as const,
        fetch: async ({ projectId, version }: FountainScenesListParams): Promise<IFountainScene[]> => {
            const params = new URLSearchParams();
            params.append('with', 'text_atoms');
            params.append('with', 'tags.subject');
            if (version) params.append('version', version);
            const data: ResponseType<IFountainScene[]> = await request(`projects/${projectId}/scenes?${params}`);
            return data.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const fountainScenesEntity: EntityDefinition<typeof fetchers> = {
    name: 'fountainScenes',
    roots: [FOUNTAIN_SCENES_ROOT],
    fetchers,
};

export type { FountainScenesListParams };
